import {actionTypes} from "./actionTypes";

export const toggleLoseMessageUpdateModal=({id,message})=>{
    return {
        type:actionTypes.TOGGLE_UPDATE_LOSE_MESSAGE_MODAL,
        payload:{id,message}
    }
}